exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title25[data-v-666d9cd4]{font-size:22px;color:#000;font-weight:400;line-height:28px;margin-bottom:20px}", ""]);

// exports
